/**
 * US-504e. `researchSeconds` → "9s" / "1m 08s" / "1h 00m".
 *
 * Always a duration with units, never a bare integer: this marker sits in the
 * card header, which is precisely where a score band used to sit (US-500), and
 * a naked number beside a candidate on a blind judging surface reads as a
 * rating no matter what it actually means.
 *
 * Defensive about its input on purpose. `research_seconds` is a nullable
 * integer column the server clamps, but the client renders whatever arrives,
 * and "-1m 60s" beside a real judgment is worse than a rounded 0.
 */
export function formatResearchDuration(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return '0s';
  const total = Math.round(seconds);

  if (total < 60) return `${total}s`;
  if (total < 3600) {
    const minutes = Math.floor(total / 60);
    // Zero-padded so the marker's width does not jump between 1m 09s and
    // 1m 10s while the recruiter's eye is on the verdict buttons beside it.
    return `${minutes}m ${String(total % 60).padStart(2, '0')}s`;
  }
  const hours = Math.floor(total / 3600);
  return `${hours}h ${String(Math.floor((total % 3600) / 60)).padStart(2, '0')}m`;
}
